import { render } from "./HeroSegment.vue?vue&type=template&id=f3423192"
import script from "./HeroSegment.vue?vue&type=script&lang=js"
export * from "./HeroSegment.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__